
import React, { useEffect } from 'react';
import { Trophy, Sparkles } from 'lucide-react';
import './Celebration.css';

const Celebration = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="celebration-overlay">
      <div className="celebration-content">
        <div className="fireworks">
          <div className="firework firework-1"></div>
          <div className="firework firework-2"></div>
          <div className="firework firework-3"></div>
        </div>
        
        <div className="celebration-message">
          <Trophy className="trophy-icon" size={64} />
          <h2>🎉 Congratulations! 🎉</h2>
          <p>{message}</p>
          <Sparkles className="sparkle sparkle-1" />
          <Sparkles className="sparkle sparkle-2" />
          <Sparkles className="sparkle sparkle-3" />
        </div>

        <button className="celebration-close" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default Celebration;
